import { Box, IconButton, InputAdornment, Skeleton, TextField, Typography } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { ButtonWithCounter } from "components/Buttons";
import CustomIcon from "components/CustomIcon";
import { EntityRow } from "components/EntityRow";
import { EntityWrapper } from "components/EntityWrapper";
import NavButton from "components/HeaderNavigation/NavButton";
import { useSnackBar, SnackBar } from "components/SnackBar";
import icons from "enums/icons";
import { convertProjectPerson, TConvertedPeopleList } from "pages/ProjectDashboard";

// Types
import { Row, RowHead, TEntityPerson } from "pages/ProjectDashboard/components/EntityList/EntityList";
import { useRef, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";
import { fetchPersonSet } from "store/slice/Project/peopleSet/peopleSetSlice";
import { convertedOpenSearchData } from "store/slice/Team";
import { convertOpenSearchToMember } from "store/slice/Team/boardStructure/boardStructure.functions";
import { getRoles } from "store/slice/Team/roles";
import { Member } from "store/slice/Team/team.types";
import { toggleLoader } from "store/slice/UI";

const data = [
    {
        id: 4215,
        name: "Long list 40661",
        ref: "/project_956/person_set_list/person_set_4215",
        shouldHighlight: false,
        shouldHide: false,
        isClone: null,
        createdBy: "FB",
        count: 95,
        people: [],
        activityLog: [
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:39:00",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:37:48",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:36:15",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:34:49",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:34:07",
                activity: "Created",
            },
        ],
    },
    {
        id: 4209,
        name: "Long list 63199",
        ref: "/project_956/person_set_list/person_set_4209",
        shouldHighlight: false,
        shouldHide: false,
        isClone: null,
        createdBy: "CA",
        count: 91,
        people: [],
        activityLog: [
            {
                id: 228,
                name: "Carlos Admin Mateo",
                datetime_utc: "2025-08-15T11:49:12",
                activity: "Updated",
            },
            {
                id: 228,
                name: "Carlos Admin Mateo",
                datetime_utc: "2025-07-12T10:03:13",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:08:58",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:08:23",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:03:49",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:02:47",
                activity: "Created",
            },
        ],
    },
    {
        id: 4206,
        name: "Long list 90854",
        ref: "/project_956/person_set_list/person_set_4206",
        shouldHighlight: false,
        shouldHide: false,
        isClone: null,
        createdBy: "DT",
        count: 100,
        people: [],
        activityLog: [
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T17:54:50",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T17:53:30",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T17:53:18",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-06-25T09:49:52",
                activity: "Created",
            },
        ],
    },
    {
        id: 4208,
        name: "Short list 11413",
        ref: "/project_956/person_set_list/person_set_4208",
        shouldHighlight: false,
        shouldHide: false,
        isClone: null,
        createdBy: "DT",
        count: 0,
        people: [],
        activityLog: [
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T17:54:54",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T17:53:35",
                activity: "Created",
            },
        ],
    },
    {
        id: 4210,
        name: "Short list 30219",
        ref: "/project_956/person_set_list/person_set_4210",
        shouldHighlight: false,
        shouldHide: false,
        isClone: null,
        createdBy: "CA",
        count: 9,
        people: [],
        activityLog: [
            {
                id: 228,
                name: "Carlos Admin Mateo",
                datetime_utc: "2025-08-15T11:49:20",
                activity: "Updated",
            },
            {
                id: 228,
                name: "Carlos Admin Mateo",
                datetime_utc: "2025-07-12T10:03:34",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:09:05",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:08:30",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:03:56",
                activity: "Created",
            },
        ],
    },
    {
        id: 4216,
        name: "Short list 90024",
        ref: "/project_956/person_set_list/person_set_4216",
        shouldHighlight: false,
        shouldHide: false,
        isClone: null,
        createdBy: "FB",
        count: 5,
        people: [],
        activityLog: [
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:39:10",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:37:57",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:36:24",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:34:58",
                activity: "Created",
            },
        ],
    },
    {
        id: 4203,
        name: "SLT 11431",
        ref: "/project_956/person_set_list/person_set_4203",
        shouldHighlight: false,
        shouldHide: false,
        isClone: null,
        createdBy: "CA",
        count: 15,
        people: [],
        activityLog: [
            {
                id: 228,
                name: "Carlos Admin Mateo",
                datetime_utc: "2025-08-15T11:49:28",
                activity: "Updated",
            },
            {
                id: 228,
                name: "Carlos Admin Mateo",
                datetime_utc: "2025-07-12T10:03:49",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:09:12",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:08:37",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T18:04:14",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T17:54:59",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-07-08T17:53:47",
                activity: "Updated",
            },
            {
                id: 81,
                name: "Diego Taso",
                datetime_utc: "2025-05-23T09:36:43",
                activity: "Created",
            },
        ],
    },
    {
        id: 4211,
        name: "SLT 17591",
        ref: "/project_956/person_set_list/person_set_4211",
        shouldHighlight: false,
        shouldHide: false,
        isClone: null,
        createdBy: "FB",
        count: 16,
        people: [],
        activityLog: [
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:39:19",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:38:06",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:36:33",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T10:35:24",
                activity: "Updated",
            },
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-07-10T14:12:06",
                activity: "Created",
            },
        ],
    },
    {
        id: 4217,
        name: "SLT 97085",
        ref: "/project_956/person_set_list/person_set_4217",
        shouldHighlight: false,
        shouldHide: false,
        isClone: null,
        createdBy: "FB",
        count: 15,
        people: [],
        activityLog: [
            {
                id: 320,
                name: "FERREIRA Bruno (External)",
                datetime_utc: "2025-09-02T11:06:45",
                activity: "Created",
            },
        ],
    },
] as TEntityPerson[];

interface SLTListProps {
    toggleSLTList: () => void;
    handleSetBoardStructure: (members: Member[]) => void;
}

const SLTList = ({ toggleSLTList, handleSetBoardStructure }: SLTListProps) => {
    const dispatch = useAppDispatch();

    const [searchParams] = useSearchParams();
    const projectId = searchParams.get("projectId");

    const { data: roles } = useAppSelector(getRoles);

    const [inputListName, setInputListName] = useState("");

    const [seletedEntity, setSelectedEntity] = useState<TEntityPerson>({} as TEntityPerson);
    const [clickedEntity, setClickedEntity] = useState<TEntityPerson | null>(null);
    const { shouldOpenSnackBar, popOverAnchorEl, handleOpenSnackBar, handleCloseSnackBar } = useSnackBar();

    const wrapperRef = useRef<HTMLElement | null | undefined>(null);

    const filteredData = data.filter((d) => d.name.includes(inputListName));

    const handleShowList = async (ev: React.MouseEvent<HTMLDivElement, MouseEvent>, data: TEntityPerson) => {
        wrapperRef.current = ev.currentTarget.parentElement?.parentElement;
        handleOpenSnackBar(ev);

        const set = unwrapResult(await dispatch(fetchPersonSet({ projectId: projectId as string, path: data.ref })));

        const people = set?.children.map((p: any) => convertProjectPerson(p.data));
        setClickedEntity((prevVal) => ({ ...(prevVal as TEntityPerson), people }));
    };

    const handleSetSelectedEntity = (data: TEntityPerson) => {
        if (data.id === seletedEntity.id) {
            setSelectedEntity({} as TEntityPerson);
        } else {
            setSelectedEntity(data);
        }
    };

    const handleFilterList = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setInputListName(event.target.value);
    };

    const backToBoardStructure = async () => {
        if (seletedEntity.id) {
            dispatch(toggleLoader(true));

            const set = unwrapResult(
                await dispatch(fetchPersonSet({ projectId: projectId as string, path: seletedEntity.ref }))
            );
            const people: TConvertedPeopleList[] = set?.children.map((p: any) => convertProjectPerson(p.data));

            const openSearchConverted = convertedOpenSearchData(people);
            const members = convertOpenSearchToMember(openSearchConverted, [], roles);

            dispatch(toggleLoader(false));

            handleSetBoardStructure(members);
        } else {
            toggleSLTList();
        }
    };

    const LoadingState = () => (
        <>
            <Skeleton variant="rectangular" animation="wave" height={25} sx={{ mb: 0.5 }} />
            <Skeleton variant="rectangular" animation="wave" height={25} sx={{ mb: 0.5 }} />
            <Skeleton variant="rectangular" animation="wave" height={25} sx={{ mb: 0.5 }} />
            <Skeleton variant="rectangular" animation="wave" height={25} sx={{ mb: 0.5 }} />
            <Skeleton variant="rectangular" animation="wave" height={25} />
        </>
    );

    return (
        <Box width="100%" position="relative">
            <Box>
                <Box mb={3} display="flex" justifyContent="right">
                    <NavButton
                        size="small"
                        isBackButton
                        variant="outlined"
                        translationId="button.backToBoardStructure"
                        onClick={backToBoardStructure}
                    />
                </Box>
                <Box mb={2}>
                    <Typography variant="subtitle1">
                        <FormattedMessage id="setup-company.team.selectSLTList" />
                    </Typography>
                </Box>
                <TextField
                    size="small"
                    id="user-filter"
                    name="user-filter"
                    autoComplete="off"
                    value={inputListName}
                    sx={{
                        mb: 2,
                        width: "100%",
                        "& .MuiInputBase-input": {
                            height: 22,
                        },
                        "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                            fontSize: 16,
                        },
                    }}
                    onChange={(event) => handleFilterList(event)}
                    placeholder="Search List by Name"
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <CustomIcon icon={icons.searchInverted} />
                            </InputAdornment>
                        ),
                    }}
                />
                <Box
                    mb={3}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "right",
                        opacity: seletedEntity.id ? 1 : 0.5,
                    }}
                >
                    <CustomIcon icon={icons.greenTick} sx={{ mr: 1, fontSize: 20 }} />
                    <Typography color="success.main" variant="body2" sx={{ fontSize: 14 }}>
                        {`${seletedEntity.id ? 1 : 0}/1 Selected`}
                    </Typography>
                </Box>
                {filteredData
                    .filter((d) => d.count)
                    .map((d) => (
                        <Box display="flex" alignItems="center" key={d.id}>
                            <IconButton onClick={() => handleSetSelectedEntity(d)}>
                                <CustomIcon
                                    icon={icons.greenTick}
                                    sx={{ opacity: seletedEntity.id === d.id ? 1 : 0.5 }}
                                />
                            </IconButton>
                            <EntityWrapper
                                size="small"
                                backgroundColor={seletedEntity.id === d.id ? "selected" : "primary"}
                                sx={{ display: "flex" }}
                            >
                                <EntityRow
                                    data={d}
                                    countButton={
                                        <Box display="flex" alignItems="center">
                                            <ButtonWithCounter
                                                count={d.count}
                                                shouldShowIcon={clickedEntity?.id === d.id}
                                                callback={(ev) => handleShowList(ev, d)}
                                            />
                                        </Box>
                                    }
                                />
                            </EntityWrapper>
                        </Box>
                    ))}
            </Box>
            <SnackBar
                maxWidth={wrapperRef.current?.getBoundingClientRect().width || 400}
                shouldOpen={shouldOpenSnackBar}
                anchorElement={popOverAnchorEl}
                title={<strong>{clickedEntity?.name}</strong>}
                handleInfoClose={(ev) => {
                    handleCloseSnackBar(ev);
                    setTimeout(() => {
                        setClickedEntity(null);
                    }, 350);
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                {...(wrapperRef.current
                    ? {
                          anchorPosition: {
                              top: wrapperRef.current?.getBoundingClientRect().bottom + 5,
                              left:
                                  wrapperRef.current?.getBoundingClientRect().left +
                                  wrapperRef.current?.getBoundingClientRect().width / 2,
                          },
                      }
                    : {})}
                content={
                    <>
                        <RowHead title={<FormattedMessage id="project.dashboard.popup.header.people.subterm" />} />
                        {!Boolean((clickedEntity as TEntityPerson)?.people?.length) ? (
                            <LoadingState />
                        ) : (
                            <Box sx={{ px: 2, maxHeight: 300, overflowY: "scroll" }}>
                                {(clickedEntity as TEntityPerson).people.map((p) => (
                                    <Row key={p.id} term={p.name} subTerm={p.jobTitle} value={p.company ?? ""} />
                                ))}
                            </Box>
                        )}
                    </>
                }
            />
        </Box>
    );
};

export default SLTList;
